export class SearchButton {
    readonly searchButtonId = 'search-button';

    public show() {
        const searchButton = this.getElement();
        searchButton?.classList.remove('d-none');
        searchButton?.classList.remove('d-lg-flex');
        searchButton?.classList.add('d-flex');
    }

    public hideOnMobile() {
        const searchButton = this.getElement();
        searchButton?.classList.add('d-none');
        searchButton?.classList.add('d-lg-flex');
        searchButton?.classList.remove('d-flex');
    }

    private getElement(): HTMLElement {
        let searchButton = document.getElementById(this.searchButtonId);
        if (searchButton instanceof HTMLElement) {
            return searchButton;
        }

        return null;
    }
}
